import * as Sentry from "@sentry/react";

export const sentryConfig = (dsn: string) => {
    Sentry.init({
      dsn: dsn,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
  
      tracesSampleRate: 1.0,
      tracePropagationTargets: [
        /^https:\/\/new\.plate\.kz/,
        /^https:\/\/plate\.kz/,
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
  
      denyUrls: [
        /mc\.yandex\.ru/,
        /googletagmanager\.com/,
        /google-analytics\.com/,
        /googleads\.g\.doubleclick\.net/,
        /googleadservices\.com/,
        /analytics\.google\.com/,
      ],
  
      beforeSend(event) {
        const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];
        const isThirdParty = frames.some((frame) =>
          /mc\.yandex\.ru|googletagmanager\.com|google-analytics\.com|gtag|googleads|googleadservices\.com|doubleclick\.net/i.test(
            frame.filename || "",
          ),
        );
        if (isThirdParty) return null;
        return event;
      },
  
      beforeBreadcrumb(breadcrumb) {
        if (breadcrumb.category === "xhr" || breadcrumb.category === "fetch") {
          const url = breadcrumb.data?.url || "";
          if (
            /mc\.yandex\.ru|googletagmanager\.com|google-analytics\.com|analytics\.google\.com|googleads|googleadservices\.com|doubleclick\.net/i.test(
              url,
            )
          ) {
            return null;
          }
        }
        return breadcrumb;
      },
    });
  }